export function logAudit(action, payload) {
    console.log('[AUDIT]', JSON.stringify({ action, payload }, null, 0));
}
